import React from 'react';
import DownloadSection from '../../components/DownloadSection/DownloadSection';
import './Download.css';

const Download = () => {
  return (
    <div className="download-page">
      <section className="hero">
        <div className="container">
          <h1>Download the AnyVolt App</h1>
          <p>Charge your electric vehicle with ease using our powerful app for iOS and Android.</p>
        </div>
      </section>

      <section className="download-content">
        <div className="container">
          <DownloadSection />
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2>App Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>Find Charging Stations</h3>
              <p>Locate nearby charging stations with real-time availability and pricing.</p>
            </div>
            <div className="feature-card">
              <h3>Reserve & Charge</h3>
              <p>Reserve charging spots in advance and manage your charging sessions.</p>
            </div>
            <div class="feature-card">
              <h3>Track & Report</h3>
              <p>Monitor your charging history and track your environmental impact.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Download;